// native.js - thin wrapper around Capacitor native features.
// Everything degrades gracefully on the web build (Capacitor plugins ship web
// implementations, and we guard with isNativePlatform / try-catch besides).
import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { StatusBar, Style } from '@capacitor/status-bar';

export const isNative = Capacitor.isNativePlatform();

// Configure the native shell once at startup.
export const initNative = async () => {
  if (!isNative) return;
  try {
    await StatusBar.setStyle({ style: Style.Dark }); // light text on our dark UI
  } catch {
    /* non-fatal: e.g. plugin unavailable */
  }
  // NB: we no longer hide the splash here. It auto-hides after
  // launchShowDuration (capacitor.config.json) so the orb artwork stays up
  // long enough to read as branding before the Welcome screen appears.
};

// Light haptic pulse for each tap; falls back to the web Vibration API.
export const tapHaptic = async () => {
  if (isNative) {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
      return;
    } catch {
      /* fall through to web fallback */
    }
  }
  if (navigator.vibrate) navigator.vibrate(30);
};

// A slightly richer pulse for reaching a milestone — distinct from the plain
// tap feedback, but still gentle (no urgency/pressure per the app's tone).
export const celebrationHaptic = async () => {
  if (isNative) {
    try {
      await Haptics.notification({ type: NotificationType.Success });
      return;
    } catch {
      /* fall through to web fallback */
    }
  }
  if (navigator.vibrate) navigator.vibrate([25, 60, 25]);
};
